import DataStore from '@/engine/stores/data-store';

class ProjectPhotoDataStore extends DataStore {

}

export default new ProjectPhotoDataStore();
